import React, { useEffect, useState } from 'react';
import Table from '../../extra/Table';
import Pagination from '../../extra/Pagination';
import Iconb from '../../extra/Iconb';
import { InfoOutlined } from '@mui/icons-material';
import Skeleton from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";
import { colors } from "../../../util/SkeletonColor";
import dayjs from "dayjs";
import DateRangePicker1 from "react-bootstrap-daterangepicker";
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../extra/Button';
import defaultImage from "../../../assets/images/default.jpg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Box, Modal, Typography } from "@mui/material";
import {
  getAffiliateWithdrawals,
  approveAffiliateWithdrawal,
  rejectAffiliateWithdrawal,
  getAffiliateWithdrawalStats,
} from '../../store/affiliateWithdraw/affiliateWithdraw.action';
import { warningAccept } from '../../../util/Alert';

const AffiliateWithdraw = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sDate, setsDate] = useState("All");
  const [eDate, seteDate] = useState("All");
  const [status, setStatus] = useState("1"); // 1=Pending, 2=Approved, 3=Rejected
  const [total, setTotal] = useState(0);

  // State for decline modal
  const [reasonData, setReasonData] = useState("");
  const [openReason, setOpenReason] = useState(false);
  const [declinedId, setDeclinedId] = useState(null);
  const [error, setError] = useState({
    reason: "",
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    backgroundColor: "background.paper",
    borderRadius: "13px",
    border: "1px solid #C9C9C9",
    boxShadow: "24px",
    padding: "19px",
  };

  const { withdrawals, stats } = useSelector((state) => state.affiliateWithdraw);

  useEffect(() => {
    dispatch(getAffiliateWithdrawals());
    dispatch(getAffiliateWithdrawalStats());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Filter data based on status
    let filteredData = withdrawals || [];
    if (status === "1") {
      filteredData = withdrawals.filter(w => w.status === 1);
    } else if (status === "2") {
      filteredData = withdrawals.filter(w => w.status === 2);
    } else if (status === "3") {
      filteredData = withdrawals.filter(w => w.status === 3);
    }
    setData(filteredData);
    setTotal(filteredData.length);
  }, [withdrawals, status]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setCurrentPage(1);
  };

  const handleApply = (event, picker) => {
    picker.element.val(
      picker.startDate.format("YYYY-MM-DD") +
      " / " +
      picker.endDate.format("YYYY-MM-DD")
    );
    const dayStart = dayjs(picker.startDate).format("YYYY-MM-DD");
    const dayEnd = dayjs(picker.endDate).format("YYYY-MM-DD");
    setsDate(dayStart);
    seteDate(dayEnd);
  };

  const handleCancel = (event, picker) => {
    picker.element.val("");
    setsDate("All");
    seteDate("All");
  };

  const handleAccept = (requestId, affiliateId) => {
    const data = warningAccept();
    data
      .then((isAccepted) => {
        if (isAccepted) {
          dispatch(approveAffiliateWithdrawal(requestId));
        }
      })
      .catch((err) => console.log(err));
  };

  const handleDecline = (requestId, affiliateId) => {
    setOpenReason(true);
    setDeclinedId({ requestId, affiliateId });
  };

  const handleCloseReason = () => {
    setOpenReason(false);
    setReasonData("");
    setError({ reason: "" });
  };

  const handleSubmit = () => {
    if (!reasonData) {
      setError({ reason: "Reason is required" });
      return;
    }
    dispatch(rejectAffiliateWithdrawal(declinedId.requestId, reasonData));
    handleCloseReason();
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => (
        <span className="text-white">
          {(currentPage - 1) * rowsPerPage + index + 1}
        </span>
      ),
    },
    {
      Header: "Unique Id",
      body: "uniqueId",
      Cell: ({ row }) => (
        <span className="mb-0 text-white">{row?.uniqueId || "N/A"}</span>
      ),
    },
    {
      Header: "Requester",
      body: "affiliate",
      Cell: ({ row }) => {
        const affiliate = row?.affiliateId;
        const user = row?.userId;
        const imageUrl = affiliate?.image || user?.image || defaultImage;
        // Reward-coin withdrawals come from plain users (no affiliate record),
        // so fall back to the user's name/email/unique id to show who it's from.
        const name =
          affiliate?.storeName ||
          affiliate?.firstName ||
          [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
          "N/A";
        const email = user?.email || affiliate?.email || "";
        const uid = user?.uniqueId || "";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: "flex-start" }}>
            {loading ? (
              <Skeleton
                height={40}
                width={40}
                style={{ borderRadius: "50%", cursor: "pointer" }}
                className="StripeElement"
                baseColor={colors?.baseColor}
                highlightColor={colors?.highlightColor}
              />
            ) : (
              <img
                src={imageUrl}
                height={45}
                width={45}
                alt="requester"
                style={{ borderRadius: "50%", cursor: "pointer" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
            )}
            <div className="text-white" style={{ textAlign: "left", lineHeight: "1.4" }}>
              <div className="mb-0"><strong>{name}</strong></div>
              {email ? <div style={{ fontSize: "12px", opacity: 0.85 }}>{email}</div> : null}
              {uid ? <div style={{ fontSize: "11px", opacity: 0.7 }}>ID: {uid}</div> : null}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Amount",
      body: "amount",
      Cell: ({ row }) => (
        <div className="text-white" style={{ lineHeight: "1.5" }}>
          {/* Amount is in the requester's local currency — show that, with
              the USD conversion underneath (don't mislabel cedis as dollars). */}
          <div><strong>{row?.currency || "USD"} {row?.amount || 0}</strong></div>
          {row?.usdEquivalent ? (
            <div style={{ fontSize: "12px", opacity: 0.8 }}>≈ ${Number(row.usdEquivalent).toFixed(2)}</div>
          ) : null}
          {row?.netPayableUsd ? (
            <div style={{ fontSize: "12px", opacity: 0.8 }}>
              Pay ${Number(row.netPayableUsd).toFixed(2)} <span title="1% processing fee">(1% fee)</span>
            </div>
          ) : null}
        </div>
      ),
    },
    {
      Header: "Payment Gateway",
      body: "paymentGateway",
      Cell: ({ row }) => (
        <span className="mb-0 text-white">{row?.paymentGateway || "N/A"}</span>
      ),
    },
    {
      Header: "Payment Details",
      body: "paymentDetails",
      Cell: ({ row }) => {
        const pd = row?.paymentDetails;
        let entries = [];
        if (Array.isArray(pd)) {
          entries = pd.map((d, i) => [String(i), String(d)]);
        } else if (pd && typeof pd === "object") {
          entries = Object.entries(pd).filter(([k]) => k !== "method");
        }
        return (
          <div className="text-white" style={{ fontSize: "13px", lineHeight: "1.6" }}>
            {entries.length > 0 ? (
              entries.map(([key, value], index) => (
                <div key={index} style={{
                  marginBottom: index !== entries.length - 1 ? "4px" : "0",
                  whiteSpace: "nowrap"
                }}>
                  {Array.isArray(pd) ? value : (<><strong>{key}:</strong> {value}</>)}
                </div>
              ))
            ) : row?.bankDetails ? (
              <div>
                {row?.bankDetails?.accountName && <div>A/C: {row?.bankDetails?.accountName}</div>}
                {row?.bankDetails?.accountNumber && <div>No: {row?.bankDetails?.accountNumber}</div>}
                {row?.bankDetails?.bankName && <div>Bank: {row?.bankDetails?.bankName}</div>}
              </div>
            ) : (
              <span style={{ color: "#888" }}>No details provided</span>
            )}
          </div>
        );
      },
    },
    {
      Header:
        status === "1"
          ? "Created Date"
          : status === "2"
            ? "Accepted Date"
            : status === "3"
              ? "Declined Date"
              : "Date",
      body: status === "1" ? "createdAt" : "updatedAt",
      Cell: ({ row }) => (
        <span className="text-white">
          {status === "1"
            ? dayjs(row.createdAt).format("DD MMM YYYY")
            : status === "2"
              ? dayjs(row.updatedAt).format("DD MMM YYYY")
              : status === "3"
                ? dayjs(row.updatedAt).format("DD MMM YYYY")
                : dayjs(row.createdAt).format("DD MMM YYYY")}
        </span>
      ),
    },
    ...(status === "3" ? [{
      Header: "Reason",
      body: "reason",
      Cell: ({ row }) => (
        <span className="mb-0 text-white" title={row?.rejectionReason}>
          {row?.rejectionReason ? (
            row?.rejectionReason.length > 20 ?
              row?.rejectionReason.substring(0, 20) + "..." :
              row?.rejectionReason
          ) : "N/A"}
        </span>
      ),
    }] : []),
    ...(status === "1" ? [{
      Header: "Action",
      body: "",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
          <Iconb
            newClass="themeFont boxCenter acptbtn userBtn fs-5"
            btnIcon={<CheckCircleIcon sx={{ color: "green" }} />}
            style={{
              borderRadius: "5px",
              width: "40px",
              cursor: "pointer",
            }}
            isImage={true}
            onClick={() => handleAccept(row?._id, row?.affiliateId?._id)}
            title="Accept Request"
          />
          <Iconb
            newClass="themeFont boxCenter killbtn userBtn fs-5"
            btnIcon={<CancelIcon sx={{ color: "red" }} />}
            style={{
              borderRadius: "5px",
              width: "40px",
              cursor: "pointer",
            }}
            isImage={true}
            onClick={() => handleDecline(row?._id, row?.affiliateId?._id)}
            title="Decline Request"
          />
        </div>
      ),
    }] : [])
  ];

  return (
    <div className="mainSellerTable">
      <div className="sellerTable">
        <div className="col-12 headname">Creator Withdrawal</div>
        <div className="sellerMain">
          <div className="tableMain mt-2">
            <div className="sellerHeader primeHeader">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-6">
                  <div
                    className="themediv"
                    style={{
                      display: "flex",
                      borderRadius: "5px",
                      backgroundColor: "#fff",
                      padding: "0px",
                      width: "fit-content",
                      margin: "10px 0px 0px 0px"
                    }}
                  >
                    <Button
                      newClass="themeFont"
                      btnName="Pending"
                      style={{
                        borderRadius: "5px 0px 0px 5px",
                        backgroundColor: status === "1" ? "#f7dada" : "transparent",
                        color: status === "1" ? "#F0C420" : "#2f2b3db3",
                        cursor: "pointer",
                        fontWeight: "500",
                        opacity: 1,
                        padding: "10px 20px",
                        border: "0.5px solid #D8D7DC",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => setStatus("1")}
                    />
                    <Button
                      newClass="themeFont"
                      btnName="Accepted"
                      style={{
                        borderRadius: "0px",
                        backgroundColor: status === "2" ? "#f7dada" : "transparent",
                        color: status === "2" ? "#F0C420" : "#2f2b3db3",
                        cursor: "pointer",
                        fontWeight: "500",
                        opacity: 1,
                        padding: "10px 20px",
                        border: "0.5px solid #D8D7DC",
                        borderLeft: "none",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => setStatus("2")}
                    />
                    <Button
                      newClass="themeFont"
                      btnName="Declined"
                      style={{
                        borderRadius: "0px 5px 5px 0px",
                        backgroundColor: status === "3" ? "#f7dada" : "transparent",
                        color: status === "3" ? "#F0C420" : "#2f2b3db3",
                        cursor: "pointer",
                        fontWeight: "500",
                        opacity: 1,
                        padding: "10px 20px",
                        border: "0.5px solid #D8D7DC",
                        borderLeft: "none",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => setStatus("3")}
                    />
                  </div>
                </div>
                <div className="col-6 d-flex justify-content-end">
                  <div className="px-3">
                    <DateRangePicker1
                      initialSettings={{
                        applyButtonClasses: "btn-default",
                        autoUpdateInput: false,
                        locale: {
                          cancelLabel: "Clear",
                        },
                        maxDate: new Date(),
                      }}
                      onApply={handleApply}
                      onCancel={handleCancel}
                    >
                      <input
                        type="text"
                        className="form-control text-center datedash my-1 white-placeholder"
                        placeholder="Select Date"
                        readOnly="readonly"
                        style={{
                          width: "13rem",
                          fontWeight: 500,
                          cursor: "pointer",
                          fontSize: "14px",
                          backgroundColor: "#fff"
                        }}
                      />
                    </DateRangePicker1>
                  </div>
                </div>
              </div>
            </div>
            <Table
              data={data}
              mapData={mapData}
              serverPerPage={rowsPerPage}
              serverPage={currentPage}
              type={"server"}
            />
            <Pagination
              component="div"
              count={total}
              type={"server"}
              onPageChange={handleChangePage}
              serverPerPage={rowsPerPage}
              totalData={total}
              serverPage={currentPage}
              setCurrentPage={setCurrentPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
        <div className="sellerFooter primeFooter"></div>
      </div>

      <Modal
        open={openReason}
        onClose={handleCloseReason}
        aria-labelledby="decline-modal-title"
        aria-describedby="decline-modal-description"
      >
        <Box sx={style} className="decline-modal">
          <div className="modal-header">
            <Typography
              id="decline-modal-title"
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 600,
                color: '#1f2937',
                display: 'flex',
                alignItems: 'center',
                gap: 2
              }}
            >
              Decline Request
            </Typography>
          </div>

          <div style={{ padding: "0px 15px" }}>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Please provide a reason for declining this request
              </label>
              <textarea
                style={{ width: "100%" }}
                className="reason-textarea w-full"
                rows={4}
                value={reasonData}
                placeholder="Enter your reason for declining this withdrawal request..."
                onChange={(e) => {
                  setReasonData(e.target.value);
                  if (!e.target.value) {
                    setError({ ...error, reason: "Reason is required" });
                  } else {
                    setError({ ...error, reason: "" });
                  }
                }}
              />
              {error.reason && (
                <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" stroke="white" strokeWidth="2" />
                    <line x1="12" y1="16" x2="12.01" y2="16" stroke="white" strokeWidth="2" />
                  </svg>
                  {error.reason}
                </p>
              )}
            </div>

            <div className="modal-buttons d-flex justify-content-end">
              <button
                onClick={handleCloseReason}
                className="close-btn"
                style={{
                  padding: "8px 20px",
                  marginRight: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  backgroundColor: "#fff",
                  cursor: "pointer"
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="submit-btn"
                style={{
                  padding: "8px 20px",
                  backgroundColor: "#F0C420",
                  border: "none",
                  borderRadius: "5px",
                  color: "#fff",
                  cursor: "pointer"
                }}
              >
                Decline Request
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AffiliateWithdraw;